import { AxiosInstance, AxiosResponse } from 'axios';
import { RunProcessDto } from './inputs/run-process.input';
import { RunProcessResponse } from './responses/run-process.response';

export class ConvertModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async runProcess(dto: RunProcessDto): Promise<AxiosResponse<RunProcessResponse>> {
    return await this.client.post<RunProcessResponse>('/convert', dto);
  }
}
